import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { runtimeLogger } from '../utils/runtime-logger.util';
import { DashboardStoreService } from '../services/store/dashboard.store.service';

@Component({
  selector: 'app-dashboard-date-selector',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './dashboard-date-selector.html',
  styleUrls: ['./dashboard-date-selector.scss']
})
export class DashboardDateSelector implements OnInit {
  startDate: string = '';
  endDate: string = '';
  isModalOpen: boolean = false;

  @Output() dateRangeChange = new EventEmitter<{ start: string, end: string }>();


  constructor(
    private readonly dashboardStoreService: DashboardStoreService
  ) { }


  ngOnInit(): void {
    // Definir datas padrão (últimos 3 meses) e emitir sincronamente
    this.setDefaultDates();
  }

  private getTodayDate(): string {
    const today = new Date();
    return today.toISOString().split('T')[0];
  }

  private getThreeMonthsAgoDate(): string {
    const today = new Date();
    const threeMonthsAgo = new Date(today);
    threeMonthsAgo.setMonth(today.getMonth() - 3); // 3 meses atrás
    return threeMonthsAgo.toISOString().split('T')[0];
  }

  get today(): string {
    return this.getTodayDate();
  }

  getDisplayDate(dateString: string): string {
    if (!dateString) return '';

    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  }

  onDateChange(): void {
    runtimeLogger.debug('DashboardDateSelector - onDateChange:', {
      start: this.startDate,
      end: this.endDate
    });

    // Só emitir se ambas as datas estiverem preenchidas
    if (this.startDate && this.endDate) {
      this.dashboardStoreService.setStartDate(this.startDate || '');
      this.dashboardStoreService.setEndDate(this.endDate || '');

      this.dateRangeChange.emit({
        start: this.startDate,
        end: this.endDate
      });
    }
  }

  clearDates(): void {
    this.startDate = '';
    this.endDate = '';
    this.dashboardStoreService.setStartDate(this.startDate || '');
    this.dashboardStoreService.setEndDate(this.endDate || '');
    // Ao limpar, emitir datas vazias
    this.dateRangeChange.emit({
      start: '',
      end: ''
    });
  }

  openDatePickerModal(): void {
    this.isModalOpen = true;
    // Previne scroll do body quando modal está aberto
    document.body.style.overflow = 'hidden';
  }

  closeeDatePickerModal(): void {
    this.isModalOpen = false;
    // Restaura scroll do body
    document.body.style.overflow = 'auto';
  }

  confirmDateSelection(): void {
    runtimeLogger.debug('DashboardDateSelector - confirmDateSelection:', {
      start: this.startDate,
      end: this.endDate
    });

    // Só emitir se ambas as datas estiverem preenchidas
    if (this.startDate && this.endDate) {
      this.dashboardStoreService.setStartDate(this.startDate || '');
      this.dashboardStoreService.setEndDate(this.endDate || '');
      this.dateRangeChange.emit({
        start: this.startDate,
        end: this.endDate
      });
    }

    this.closeeDatePickerModal();
  }

  private setDefaultDates(): void {
    this.startDate = this.dashboardStoreService.startDate() || this.getThreeMonthsAgoDate();
    this.endDate = this.dashboardStoreService.endDate() || this.getTodayDate();

    // Emitir as datas padrão SINCRONAMENTE
    runtimeLogger.debug('DashboardDateSelector - setDefaultDates:', {
      start: this.startDate,
      end: this.endDate
    });

    if (this.startDate && this.endDate) {
      this.dashboardStoreService.setStartDate(this.startDate || '');
      this.dashboardStoreService.setEndDate(this.endDate || '');
      this.dateRangeChange.emit({
        start: this.startDate,
        end: this.endDate
      });
    }
  }
}
